/**
 * Storyline Context Manager
 * Manages global context for Storyline integration (helpFlowId, mainStepId)
 * This context is automatically injected into all LLM API calls
 */

import { logger } from '../utils/logger';

// Create component logger for StorylineContext
const storylineContextLogger = logger.withComponent('StorylineContext');

export interface StorylineContext {
  helpFlowId?: string;
  mainStepId?: string;
}

class StorylineContextManager {
  private context: StorylineContext = {};

  /**
   * Set or update the Storyline context
   * @param context - Partial context to merge with existing context
   */
  setContext(context: Partial<StorylineContext>) {
    this.context = { ...this.context, ...context };
    
    if (process.env.NODE_ENV === 'development') {
      storylineContextLogger.info('[StorylineContext] Context updated:', this.context);
    }
  }

  /**
   * Get a copy of the current context
   * @returns Current Storyline context
   */
  getContext(): StorylineContext {
    return { ...this.context };
  }

  /**
   * Clear all context
   */
  clear() {
    this.context = {};
    
    if (process.env.NODE_ENV === 'development') {
      storylineContextLogger.info('[StorylineContext] Context cleared');
    }
  }

  /**
   * Check if context has any values
   * @returns true if any context values are set
   */
  hasContext(): boolean {
    return !!(this.context.helpFlowId || this.context.mainStepId);
  }
}

// Export singleton instance
export const storylineContextManager = new StorylineContextManager();